export default function closeFact() {
  document.addEventListener('click', (e) => {
    if (e.target.id == 'close-fact-modal') {
      e.preventDefault();
      document.getElementById('fact-modal').innerHTML = '';
    }
  });
}
